import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import urlJoin from 'url-join';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

// const getNameSpace = (appName) => {
//   switch (appName) {
//     case 'lno':
//       return [
//         'exams',
//         'classroom',
//       ];
//     default:
//       return ['translations', 'exams', 'registerLogin', 'classroom'];
//   }
// };

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: urlJoin(process.env.PUBLIC_PATH ?? '/', `/locales/{{lng}}/{{ns}}.json`),
    },
    fallbackLng: 'th',
    // lng: 'th',
    // have a common namespace used around the full app
    ns: ['translations', 'exams', 'registerLogin', 'classroom', 'myPath'],
    defaultNS: 'translations',

    debug: false,
    whitelist: ['th'],

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: (value, format, lng) => {
        if (value && (value instanceof Date || dayjs(value).isValid())) {
          return dayjs(value).format(format);
        }
        return value;
      },
    },

    react: {
      // default value is true
      // which means, i18next prefers having <Suspense /> shown instead of TRANSLATION.KEY.SOMETHING
      // while it's fetching translation behind
      useSuspense: false,
    },

    // react i18next special options (optional)
    // override if needed - omit if ok with defaults
    /*
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true,
    }
    */

    detection: {
      lookupQuerystring: 'lang',
    },
  });

i18n.on('languageChanged', (lng) => {
  dayjs.locale(lng);
});

export default i18n;
